import axios from "../axios";
// 分页查询班级
export const getClassList = (data) => {
  return axios({
    url: "/console/homework_class/page",
    method: "GET",
    data: data,
  });
};

// 获取年级列表
export const getGradeList = (data) => {
  return axios({
    url: "/console/school/grade",
    method: "GET",
    data: data,
  });
};

// 添加班级
export const addClass = (data) => {
  return axios({
    url: "/console/homework_class/insert",
    method: "POST",
    data,
  });
};

// 编辑班级
export const editClass = (data) => {
  return axios({
    url: "/console/homework_class/update",
    method: "POST",
    data,
  });
};

// 根据ClassId获取教师成员列表
export const getTeacherList = (data) => {
  return axios({
    url: "/console/teacher/pageByHomeworkClass",
    method: "GET",
    data: data,
  });
};

// 禁用班级
export const disClass = (data) => {
  return axios({
    url: "/console/homework_class/switch",
    method: "POST",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/classManagement.js